<script>
import TwModal from '@/components/generic/modal/tw-modal.vue'
import TwWizard from '@/components/generic/wizard/tw-wizard.vue'
import TwWizardPage from '@/components/generic/wizard/tw-wizard-page.vue'
import { useAuthStore } from '@/stores/auth.js'
import { useOrganizationPublicStore } from '@/stores/organizationPublic.js'
import TwTextarea from '@/components/generic/forms/tw-textarea.vue'
import TwInput from '@/components/generic/forms/tw-input.vue'
import TwValidationErrors from '@/components/generic/tw-validation-errors.vue'
import AddressEditCard from '@/components/address/address-edit-card.vue'
import TwCheckbox from '@/components/generic/forms/tw-checkbox.vue'
import TwButton from '@/components/generic/tw-button.vue'
import TwPassword from '@/components/generic/forms/tw-password.vue'
import axios from 'axios'
export default {
  name: 'OrganizationRegisterIntegratedModal',
  components: { TwButton, TwPassword, TwCheckbox, AddressEditCard, TwValidationErrors, TwInput, TwTextarea, TwWizardPage, TwWizard, TwModal },
  data() {
    return {
      UserAccount: null,
      LoadingSigningUp: false,
      LoadingValidatingSigningUp: false,
      ValidationErrorMessage: null,
      ValidationErrorMessageOrganization: null,
      OrganizationName: null,
      OrganizationTaxId: null,
      OrganizationNonProfit: true,
      OrganizationWebsiteUrl: null,
      OrganizationDescription: null,
      OrganizationPhone: null,
      OrganizationCountry: null,
      OrganizationAddress: {},
      UserFirstName: null,
      UserLastName: null,
      UserEmail: null,
      UserEmailConfirm: null,
      UserExistingAccount: null,
      UserPassword: null,
      UserPasswordConfirmation: null
    }
  },
  methods: {
    open() {
      this.$refs.modal.open()
    },
    userPayload() {
      return {
        user_name: this.UserExistingAccount === true ? null : this.UserFirstName + ' ' + this.UserLastName,
        user_email: this.UserEmail,
        user_email_confirm: this.UserExistingAccount === true ? null : this.UserEmailConfirm,
        user_existing_account: this.UserExistingAccount === true,
        user_password: this.UserPassword,
        user_password_confirmation: this.UserExistingAccount === true ? null : this.UserPasswordConfirmation
      }
    },
    selectExistingAccount(value) {
      this.ValidationErrorMessage = null
      this.UserExistingAccount = value
      this.UserPassword = null
      this.UserPasswordConfirmation = null

      if (value === true) {
        this.UserFirstName = null
        this.UserLastName = null
        this.UserEmailConfirm = null
      }
    },
    async validateOrganizationData() {
      try {
        this.ValidationErrorMessageOrganization = null
        this.LoadingValidatingSigningUp = true
        await axios.post('/api/v1/signup', {
          organization_name: this.OrganizationName,
          organization_tax_id: this.OrganizationTaxId,
          organization_nonprofit: this.OrganizationNonProfit,
          organization_website_url: this.OrganizationWebsiteUrl,
          organization_description: this.OrganizationDescription,
          organization_phone: this.OrganizationPhone,
          organization_address_street: this.OrganizationAddress.address_street,
          organization_address_city: this.OrganizationAddress.address_city,
          organization_address_state: this.OrganizationAddress.address_state,
          organization_address_zip: this.OrganizationAddress.address_zip,
          organization_address_country: this.OrganizationAddress.address_country
        }, {
          headers: {
            'Precognition': 'true',
            'Precognition-Validate-Only': 'organization_name,organization_tax_id,organization_nonprofit,organization_website_url,organization_description,organization_phone,organization_address_street,organization_address_city,organization_address_state,organization_address_zip,organization_address_country'
          },
        })
        this.LoadingValidatingSigningUp = false
      } catch (e) {
        console.error(e)
        this.LoadingValidatingSigningUp = false
        if (e.response) {
          this.ValidationErrorMessageOrganization = e.response.data
        }
        throw e
      }

    },
    async validateUserData() {
      try {
        this.ValidationErrorMessage = null
        this.LoadingSigningUp = true
        await axios.post('/api/v1/signup', this.userPayload(), {
          headers: {
            'Precognition': 'true',
            'Precognition-Validate-Only': 'user_name,user_email,user_email_confirm,user_existing_account,user_password,user_password_confirmation'
          },
        })
        this.LoadingSigningUp = false
      } catch (e) {
        console.error(e)
        this.LoadingSigningUp = false
        if (e.response) this.ValidationErrorMessage = e.response.data
        throw e
      }
    },
    async signup(precognition = false) {
      try {
        this.ValidationErrorMessage = null
        this.LoadingSigningUp = true
        console.log('Signup:',precognition)
        const { data } = await axios.post('/api/v1/signup', {
          organization_name: this.OrganizationName,
          organization_tax_id: this.OrganizationTaxId,
          organization_nonprofit: this.OrganizationNonProfit,
          organization_website_url: this.OrganizationWebsiteUrl,
          organization_description: this.OrganizationDescription,
          organization_phone: this.OrganizationPhone,
          organization_address_street: this.OrganizationAddress.address_street,
          organization_address_city: this.OrganizationAddress.address_city,
          organization_address_state: this.OrganizationAddress.address_state,
          organization_address_zip: this.OrganizationAddress.address_zip,
          organization_address_country: this.OrganizationAddress.address_country,
          ...this.userPayload()
        }, precognition ? { headers: { 'Precognition': 'true' } } : {})
        this.LoadingSigningUp = false
        if(data.autologin_token) {
          // we have an autologin token, so we need to log the user in automatically
          await useAuthStore().loginViaToken(data.autologin_token)
          await this.$refs.modal.close()
          await this.$router.push({ name: 'DashboardPage' })
        }
      } catch (e) {
        console.error(e)
        this.LoadingSigningUp = false
        if (e.response) this.ValidationErrorMessage = e.response.data
        throw e
      }
    },
    async finishRegistration() {
      await this.validateUserData()
      await this.signup()
    },
    async userRegistered(userRegistered) {
      try {
        this.LoadingCreatingOrganization = true
        await useOrganizationPublicStore().itemPatch({
          id: this.Organization.id,
          owner_user_id: userRegistered.id
        })
        this.LoadingCreatingOrganization = false
        await this.$refs.modal.close()
        await useAuthStore().login({
          email: this.UserAccount.email,
          password: this.UserAccount.password,
        })
        await this.$router.push({ name: 'DashboardPage' })
      } catch (e) {
        this.LoadingCreatingOrganization = false
      }
    },
    async nextPage() {
      // first we need to validate the organization info
      await this.validateOrganizationData()
      // then we go to the next page:
      this.$refs.wizard.nextPage()
    }
  }
}
</script>

<template>
  <tw-modal ref="modal" no-footer :loading="LoadingSigningUp" modal-id="organization-register-modal">
    <tw-wizard ref="wizard" no-navigation>
      <tw-wizard-page>
        <h3>Signup and Start Fundraising with GroupRev</h3>
        <p class="my-4">
          Signup below and get started fundraising today with GroupRev. GroupRev is 100% free fundraising platform for non-profits and causes.
        </p>
        <fieldset>
          <div class="form-spacing">
            <tw-input v-model="OrganizationName" required label="Organization Name*" />
            <address-edit-card v-model="OrganizationAddress" />
            <tw-input v-model="OrganizationTaxId" required label="Tax ID Number*" />
            <tw-checkbox v-model="OrganizationNonProfit" label="My organization tax exempt (only non profit organizations are supported for now)" />
            <tw-input v-model="OrganizationWebsiteUrl" label="Website" />
            <tw-textarea v-model="OrganizationDescription" required label="Description">
              <template #under>
                <p class="text-sm text-gray-600 mt-2">
                  Write a short description about your organization that will be shown on your profile.
                </p>
              </template>
            </tw-textarea>
            <div class="grid sm:grid-cols-2 gap-2 sm:gap-4">
              <tw-input v-model="OrganizationPhone" required label="Phone" />
            </div>
            <tw-validation-errors :validation-result-error="ValidationErrorMessageOrganization" />
          </div>
        </fieldset>
        <div class="mt-10 flex justify-end">
          <tw-button @click="nextPage">
            Next: User <icon icon="chevron-right" />
          </tw-button>
        </div>
      </tw-wizard-page>
      <tw-wizard-page>
        <h3>Your information</h3>
        <p class="my-4">
          Choose how you want to sign in as the primary user for this organization.
        </p>
        <fieldset :disabled="LoadingSigningUp">
          <div class="grid gap-3 sm:grid-cols-2">
            <tw-button :variant="UserExistingAccount === false ? 'dark' : 'secondary'" block @click="selectExistingAccount(false)">
              Create New Account
            </tw-button>
            <tw-button :variant="UserExistingAccount === true ? 'dark' : 'secondary'" block @click="selectExistingAccount(true)">
              Use Existing Account
            </tw-button>
          </div>

          <template v-if="UserExistingAccount !== null">
            <div v-if="UserExistingAccount === false" class="grid sm:grid-cols-2 gap-2 sm:gap-4 mt-6">
              <tw-input v-model="UserFirstName" required label="First Name*" />
              <tw-input v-model="UserLastName" required label="Last Name*" />
            </div>
            <div class="grid sm:grid-cols-2 gap-2 sm:gap-4 mt-4">
              <tw-input v-model="UserEmail" required label="Email*" />
              <tw-input v-if="UserExistingAccount === false" v-model="UserEmailConfirm" required label="Confirm Email*" />
            </div>
            <div class="grid sm:grid-cols-2 gap-2 sm:gap-4 mt-2">
              <tw-password v-model="UserPassword" required :label="UserExistingAccount === true ? 'Current Password*' : 'Create Password*'" />
              <tw-password v-if="UserExistingAccount === false" v-model="UserPasswordConfirmation" required label="Confirm Password*" />
            </div>
          </template>

          <tw-validation-errors v-if="ValidationErrorMessage" :validation-result-error="ValidationErrorMessage" @close="ValidationErrorMessage = null" />
        </fieldset>
        <div class="mt-10 flex justify-between">
          <tw-button variant="secondary" @click="$refs.wizard.previousPage()">
            <icon icon="chevron-left" /> Back to Organization
          </tw-button>
          <tw-button :loading="LoadingSigningUp" :disabled="UserExistingAccount === null" @click="finishRegistration">
            Finish registration
          </tw-button>
        </div>
      </tw-wizard-page>
    </tw-wizard>
    <template #ok>
      Register Organization
    </template>
  </tw-modal>
</template>

<style scoped>

</style>
